// extracted by mini-css-extract-plugin
export default {"form":"ForgotPassword_form__0SK6Q"};